<template>
  <!-- 可编辑时候的所有信息展示 -->
  <div class="address">
    <div v-show="!showEditBox" style="font-size: 18px;font-weight: bold;color: #ed1c24;margin: 6px 0 10px;">
      {{ type === 'one_design_address' ? $t('user-productInfo-design/inDesign') : '' }}
      {{ type === 'two_design_address' ? $t('user-productInfo-design/designOffice') : '' }}
      {{ type === 'three_design_address' ? $t('user-productInfo-design/designer') : '' }}
    </div>
    <span v-show="!showEditBox">
      <span v-if="isSet">
        <span class="redStar" />{{ $t('view-components-components/addMessageP1') }}
      </span>
      <a-button v-if="isSet && ($route.path == '/user/registration' || $route.path == '/user/myProduct')" type="primary" style="margin-left: 10px;" @click="addAddress">{{ $t('view-components-components/addMessageP2') }}</a-button>
    </span>
    <div
      v-show="!showEditBox"
      class="list"
    >
      <div
        v-for="(i, index) in list"
        :key="i.id"
      >
        <div
          v-show="(() => {
            // 修改显示逻辑：如果有contact数据或者不在/user/address路径下，都显示
            const hasContact = i.contact && i.contact.length > 0;
            const hasParticipant = hasContact && i.contact.findIndex(b => b.participant_type) !== -1;
            return $route.path === '/user/address' ? (hasContact && hasParticipant) : true;
          })()"
          class="item"
          :style="{'margin-left': isSet ? '50px' : 0 }"
          @click="choose(index)"
        >
          <a-checkbox-group :value="chooseIndex" name="select" @change="chooseBox($event, index)">
            <a-checkbox class="itemRadio" :value="index" />
          </a-checkbox-group>

          <!-- 显示单位信息 -->
          <div v-if="i.company_name" style="margin-bottom: 15px;">
            <a-row :gutter="24">
              <a-col span="6">
                <b>{{ $t('register/name') }}:</b>
              </a-col>
              <a-col span="18">
                {{ i.company_name }}
              </a-col>
            </a-row>
            <a-row :gutter="24" style="margin-top: 7px;">
              <a-col span="6">
                <b>{{ $t('user-productInfo-brand/address') }}:</b>
              </a-col>
              <a-col span="18">
                {{ i.country }} {{ i.province }} {{ i.city }} {{ i.street }}
              </a-col>
            </a-row>
          </div>

          <!-- 显示联系人信息 -->
          <div
            v-for="(item, index2) in i.contact"
            :key="index2"
          >
            <a-row
              :gutter="24"
            >
              <a-col span="3">
                <b>{{ $route.path !== '/user/registration' ? $t('register/profile') : $t('user-productInfo-brand/profile') }}</b>
              </a-col>
              <a-col span="4">
                {{ $t('user-account-address/name') }}
              </a-col>
              <a-col span="5">
                <b>{{ $t('register/identificationNumber') }}</b>
              </a-col>
              <a-col span="5">
                {{ $t('user-productInfo-brand/phone') }}
              </a-col>
              <a-col v-if="$route.path === '/user/registration'" span="4">
                {{ $t('register/otherName') }}
              </a-col>
            </a-row>
            <a-row
              :gutter="24"
              style="margin-top: 7px;"
            >
              <a-col span="3" />
              <a-col span="4">
                <span>{{ item.name }} </span>
                <!-- <span v-if="$i18n.locale === 'en'">{{ item.firstname }} {{ item.lastname }}</span>
                <span v-if="$i18n.locale !== 'en'">{{ item.lastname }} {{ item.firstname }}</span> -->
              </a-col>
              <a-col span="5" style="word-break: break-all; white-space: normal;">
                <!-- {{ $i18n.locale === 'en' ? i.company_ename : i.company_name }} -->
                {{ item.sfzhm }}
              </a-col>
              <a-col span="5" style="word-break: break-all; white-space: normal;">
                {{ item.phone }}
              </a-col>
              <a-col v-if="$route.path === '/user/registration'" span="4" style="overflow: hidden;text-overflow: ellipsis">
                {{ item.other_name }}
              </a-col>
              <a-col :span="$route.path === '/user/registration' ? 2 : 3" style="margin-left: 20px; margin-top: -30px;">
                <a-button
                  v-if="index2 == 0"
                  type="primary"
                  @click="editAddress(index)"
                >
                  {{ $t('user-address/edit') }}
                </a-button>
              </a-col>
            </a-row>
          </div>

          <!-- 如果没有联系人信息，显示提示 -->
          <div v-if="!i.contact || i.contact.length === 0" style="color: #999; font-style: italic;">
            {{ $t('user-address/noContactInfo') || '暂无联系人信息' }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showEditBox"
      :class="showAll ? 'editBox all' : 'editBox'"
      :style="$store.getters.user.participant_type == 1 ? {} : {width: '100%'}"
    >
      <a-form-model
        ref="ruleForm"
        class="ant-advanced-search-form"
        :model="form"
        :rules="rules"
      >
        <a-row :gutter="24">
          <div v-for="(item, index) in form.user" :key="index" class="user">
            <a-col v-if="form.user.length > 1" span="24">
              <a-button style="float: right;" size="large" @click="reduceUser(index)">
                <a-icon
                  type="delete"
                  class="del"
                />
              </a-button>
            </a-col>
            <a-col v-if="$route.path == '/user/address'" span="24">
              <a-form-model-item
                ref="participant_type"
                :prop="`user[${index}].participant_type`"
                :label="$t('register/participantType')+$t('register/participantTypeTip')"
                :rules="{ required: true, message: $t('user-address/pparticipantType'), trigger: ['change', 'blur'] }"
                required
              >
                <a-radio-group v-model="form.user[index].participant_type">
                  <a-radio value="1">{{ $t('register/person') }}</a-radio>
                  <a-radio value="2">{{ $t('register/company') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="($route.path == '/user/address' || $store.getters.user.participant_type == 1) ? 12 : 24">
              <a-form-model-item
                ref="name"
                style="width: 50%;"
                :prop="`user[${index}].name`"
                :label="$t('user-productInfo-brand/name')"
                :rules="{ required: true, message: $t('admin-user-user/pname'), trigger: ['change', 'blur'] }"
                required
              >
                <a-input v-model="form.user[index].name" :placeholder="($route.path == '/user/address' || $store.getters.user.participant_type == 1) ? '' : '请输入第一设计师姓名'" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="($route.path == '/user/address' || $store.getters.user.participant_type == 1)" span="12">
              <a-form-model-item
                ref="form"
                :prop="`user[${index}].form`"
                :label="$t('user-productInfo-brand/form')"
                :rules="{ required: true, message: $t('user-address/pname'), trigger: ['change', 'blur'] }"
                required
              >
                <a-radio-group v-model="form.user[index].form">
                  <a-radio value="1">{{ $t('register/male') }}</a-radio>
                  <a-radio value="2">{{ $t('register/female') }}</a-radio>
                  <!-- <a-radio value="3">{{ $t('register/notToSay') }}</a-radio> -->
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="!($route.path == '/user/address' || $store.getters.user.participant_type == 1) ? 24 : 12">
              <a-form-model-item
                ref="phone"
                :style="!($route.path == '/user/address' || $store.getters.user.participant_type == 1) ? 'width: 50%' : ''"
                :prop="`user[${index}].phone`"
                :label="$t('user-productInfo-brand/phone')"
                :rules="{ required: ($route.path == '/user/address' || $store.getters.user.participant_type == 1), message: $t('admin-user-user/pinputp'), trigger: ['change', 'blur']}"
                :required="($route.path == '/user/address' || $store.getters.user.participant_type == 1)"
              >
                <a-input v-model="form.user[index].phone" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="($route.path == '/user/address' || $store.getters.user.participant_type == 1)" span="12">
              <a-form-model-item
                ref="email"
                :prop="`user[${index}].email`"
                :label="$t('user-productInfo-brand/email')"
                :rules="[{ required: true, message: $t('admin-user-user/pemaill'), trigger: ['change', 'blur']}, { validator: emailValidate, trigger: ['change', 'blur'] }]"
                required
              >
                <a-input v-model="form.user[index].email" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="($route.path == '/user/address' || $store.getters.user.participant_type == 1)" span="12">
              <a-form-model-item
                ref="identity_type"
                :prop="`user[${index}].identity_type`"
                :label="$t('register/identityType')"
                :rules="{ required: true, message: $t('register/select-identity-type'), trigger: ['change', 'blur'] }"
                required
              >
                <a-select
                  v-model="form.user[index].identity_type"
                  show-search
                >
                  <a-select-option
                    value="1"
                  >
                    {{ $t('register/identity') }}
                  </a-select-option>
                  <a-select-option
                    value="2"
                  >
                    {{ $t('register/passport') }}
                  </a-select-option>
                  <a-select-option
                    value="3"
                  >
                    {{ $t('register/accessPass') }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="!($route.path == '/user/address' || $store.getters.user.participant_type == 1) ? 24 : 12">
              <a-form-model-item
                ref="sfzhm"
                :style="!($route.path == '/user/address' || $store.getters.user.participant_type == 1) ? 'width: 50%' : ''"
                :prop="`user[${index}].sfzhm`"
                :label="$t('register/identificationNumber')"
                :rules="[{ required: ($route.path == '/user/address' || $store.getters.user.participant_type == 1), message: $t('register/select-identification-number'), trigger: ['change', 'blur']},]"
                :required="($route.path == '/user/address' || $store.getters.user.participant_type == 1)"
              >
                <a-input v-model="form.user[index].sfzhm" />
              </a-form-model-item>
            </a-col>
            <!-- 其他设计师字段已移动到职业/职务同行 -->
          </div>
          <a-col v-if="($route.path == '/user/address' || $store.getters.user.participant_type == 1)" span="12">
            <a-form-model-item
              ref="company_name"
              prop="company_name"
              :label="$t('register/name')"
            >
              <a-input v-model="form.company_name" />
            </a-form-model-item>
          </a-col>
          <a-col
            v-if="($route.path == '/user/address' || $store.getters.user.participant_type == 1)"
            span="12"
          >
            <a-form-model-item
              ref="street"
              prop="street"
              :label="$t('user-productInfo-brand/address')"
            >
              <a-input v-model="form.street" />
            </a-form-model-item>
          </a-col>
          <!-- 职位在地址后面展示，脱离for循环，要写死index -->
          <a-col v-if="($route.path == '/user/address' || $store.getters.user.participant_type == 1)" span="12">
            <a-form-model-item
              ref="position"
              :prop="`user[${0}].position`"
              :label="$t('user-productInfo-brand/position')"
            >
              <a-input v-model="form.user[0].position" />
            </a-form-model-item>
          </a-col>
          <!-- 其他设计师字段（仅在注册页面显示，与职业/职务同行） -->
          <a-col v-if="$route.path === '/user/registration' || $route.path === '/user/myProduct'" span="12">
            <a-form-model-item
              ref="other_name"
              :prop="`user[${0}].other_name`"
              :label="$t('register/otherName')"
            >
              <a-input v-model="form.user[0].other_name" placeholder="多个设计师请用逗号隔开 " />
            </a-form-model-item>
          </a-col>
          <a-col v-if="($route.path == '/user/registration' || $route.path == '/user/registration') && $store.getters.user.participant_type == 2" span="24">
            <a-button @click="save">
              {{ $t('admin-profile-edit/save') }}
            </a-button>
          </a-col>

        </a-row>
        <a-row v-if="($route.path == '/user/address' || $store.getters.user.participant_type == 1)" :gutter="12">
          <a-col span="6">
            <a-form-model-item
              ref="country"
              prop="country"
              :label="$t('user-productInfo-brand/country')"
              required
            >
              <a-select
                v-model="form.country"
                show-search
              >
                <a-select-option
                  v-for="i in countryFormat[$i18n.locale || 'zh']"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-if="form.country === 'China' || form.country === '中国'" span="6">
            <a-form-model-item
              ref="province"
              prop="province"
              :label="$t('admin-judge420/name7')"
            >
              <a-select
                v-model="form.province"
                show-search
                :placeholder="$t('admin-judge420/name7')"
                @change="form.city = ''"
              >
                <a-select-option
                  v-for="i in provinceData"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item
              ref="city"
              prop="city"
              :label="$t('user-productInfo-brand/city')"
              required
            >
              <a-input v-if="form.country !== 'China' && form.country !== '中国'" v-model="form.city" />
              <a-select
                v-if="form.country === 'China' || form.country === '中国'"
                v-model="form.city"
                show-search
                :placeholder="$t('user-productInfo-brand/city')"
                @change="form.region = ''"
              >
                <a-select-option
                  v-for="i in cityData"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
              <!-- <a-select
                v-if="form.country === 'China' || form.country === '中国'"
                v-model="form.city"
                show-search
              >
                <a-select-option
                  v-for="i in cityFormat[$i18n.locale || 'zh']"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select> -->
            </a-form-model-item>
          </a-col>
          <a-col v-if="(form.country === 'China' || form.country === '中国') && (form.city === 'Zhangzhou' || form.city === '漳州')" span="6">
            <a-form-model-item
              ref="region"
              prop="region"
              :label="$t('user-productInfo-brand/region')"
              required
            >
              <a-select
                v-model="form.region"
                show-search
                :placeholder="$t('user-productInfo-brand/region')"
              >
                <a-select-option
                  v-for="i in zhangzhouRegionFormat[$i18n.locale || 'zh']"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="($route.path == '/user/address' || $store.getters.user.participant_type == 1)">
          <a-col span="12">
            <a-form-model-item
              ref="homepage"
              prop="homepage"
              :label="$t('user-productInfo-brand/homepage')"
            >
              <a-input v-model="form.homepage" />
            </a-form-model-item>
          </a-col>
          <div class="tip">
            {{ $t('register/tip4') }}
            <font color="#ed1c24">
              *
            </font>{{ $t('register/tip5') }}
          </div>
          <!-- <a-col
            span="24"
            class="subTitle"
          >
            {{ ['one_design_address', 'two_design_address', 'three_design_address'].indexOf(type) !== -1 ? $t('register/profile') : $t('user-productInfo-brand/profile') }}
            <a-button size="large" style="float: right;" type="primary" @click="addUser">{{ $t("view-components-components/addMore") }}{{ ['one_design_address', 'two_design_address', 'three_design_address'].indexOf(type) !== -1 ? $t('view-components-components/designer') : $t('view-components-components/contact') }}</a-button>
          </a-col> -->
        </a-row>
      </a-form-model>
    </div>
    <a-button
      v-show="!showEditBox && list.length > 0"
      v-if="isSet"
      type="primary"
      style="float: left;margin-left: 49px;"
      @click="setAddress"
    >
      {{ $t('view-components-components/confirm') }}
    </a-button>
    <footer v-if="showEditBox">
      <a-button @click="cancel">
        {{ $t('admin-profile-edit/cancel') }}
      </a-button>
      <a-button @click="save">
        {{ $t('admin-profile-edit/save') }}
      </a-button>
    </footer>
  </div>
</template>
<script>
import { address, createAddress, editAddress, addressGetDesignInfo } from '@/api/address'
import countryFormat from '@/utils/country.js'
import cityFormat from '@/utils/city.js'
import zhangzhouRegionFormat from '@/utils/zhangzhouRegion.js'
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
import { getLKey } from '@/utils/auth'
import area_cn from '@/utils/area_cn.js' // 中文
import area_en from '@/utils/area_en.js' // 英文

const i18n = { zh, en }
const lang = getLKey()

function emailValidate(rule, value, callback) {
  // if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
  // callback()
  // } else {
  //   callback(new Error('邮箱格式不正确'))
  // }
  if (value.indexOf('@') !== -1) {
    callback()
  } else {
    callback(new Error(i18n[lang]['view-components-components/mailError']))
  }
}

export default {
  props: {
    isSet: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: ''
    },
    showAll: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      emailValidate: emailValidate,
      form: {
        participant_type: '',
        company_name: '',
        // company_ename: '',
        street: '',
        province: '',
        city: '',
        region: '',
        country: '中国',
        homepage: '',
        address_email: '',
        address_fax: '',
        user: [{
          participant_type: '',
          form: '',
          firstname: '',
          lastname: '',
          name: '',
          email: '',
          position: '',
          phone: '',
          identity_type: '',
          sfzhm: '',
          other_name: ''
        }]
      },
      rules: {
        company_name: [
          { required: true, message: this.$t('user-address/company'), trigger: ['change', 'blur'] }
        ],
        // company_ename: [
        //   { required: true, message: this.$t('user-address/ecompany'), trigger: ['change', 'blur'] }
        // ],
        street: [
          { required: true, message: this.$t('user-address/paddress'), trigger: ['change', 'blur'] }
        ],
        city: [
          { required: true, message: this.$t('register/pcity'), trigger: ['change', 'blur'] }
        ],
        country: [
          { required: true, message: this.$t('register/pcountry'), trigger: ['change', 'blur'] }
        ],
        region: [
          { required: true, message: i18n[lang]['register/pregion'], trigger: ['change', 'blur'] }
        ]
      },
      isEdit: false,
      showEditBox: false,
      chooseIndex: [],
      editIndex: -1,
      list: [],
      countryFormat: countryFormat,
      cityFormat: cityFormat,
      zhangzhouRegionFormat: zhangzhouRegionFormat
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    provinceData() { // 所有的省份
      return this.locale === 'en' ? area_en.provinceData : area_cn.provinceData
    },
    cityData() { // 所有的城市
      const area = this.locale === 'en' ? area_en : area_cn
      return area.cityData[this.form.province]
    }
  },
  created() {
    console.log('$route.path', this.$route.path)
    console.log('type', this.type)
    this.getList()
  },
  methods: {
    getList() {
      address(this.$route.query.userId, { per_page: 999 })
        .then(res => {
          res.data.forEach(i => {
            i.contact.forEach(j => {
              this.numberToString(j, 'participant_type')
              this.numberToString(j, 'identity_type')
              this.numberToString(j, 'form')
            })
          })
          console.log('res.data', res.data)
          this.list = res.data
        })
        .catch(res => {
          console.error(res)
        })
    },
    // 数字转换成字符串
    numberToString(obj, value) {
      if (typeof obj[value] === 'number') {
        obj[value] = obj[value].toString()
      }
    },
    save() {
      const data = JSON.parse(JSON.stringify(this.form))

      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          if (!this.isEdit) {
            if (this.$route.query.userId) data.user_id = this.$route.query.userId
            createAddress(data)
              .then(() => {
                this.$message.success({
                  content: i18n[lang]['admin-password-password/savey'],
                  key: 'message',
                  duration: 2
                })
                this.showEditBox = false
                setTimeout(() => {
                  this.getList()
                }, 2000)
              })
              .catch(res => {
                console.error(res)
              })
          } else {
            const id = this.list[this.editIndex].id

            if (this.$route.query.userId) data.user_id = this.$route.query.userId
            // 如果接口有给participant_type，要原样参数传回去
            if (this.$route.path !== '/user/address') {
              // 保留原有的participant_type，不删除
              console.log('data-asdghioasdhio', data)
              // 如果用户数据中有participant_type，保留原值
              data.user.forEach(a => {
                // 只有在participant_type为空或undefined时才设置为undefined
                if (a.participant_type === '' || a.participant_type === null || a.participant_type === undefined) {
                  a.participant_type = undefined
                }
              })
            }
            editAddress(id, data)
              .then(() => {
                this.$store.dispatch('user/init')
                this.$message.success({
                  content: i18n[lang]['admin-rewards-rewards/modify'],
                  key: 'message',
                  duration: 2
                })
                this.showEditBox = false
                setTimeout(() => {
                  this.getList()
                }, 2000)
              })
              .catch(res => {
                console.error(res)
              })
          }
        } else {
          this.$message.warning({ content: this.$t('view-components-components/perfect'), key: 'message', duration: 4 })
          console.log('error submit!!')
          return false
        }
      })
    },
    cancel() {
      this.showEditBox = false
      this.getList()
    },
    addAddress() {
      this.chooseIndex = []
      this.editIndex = -1
      this.isEdit = false
      this.showEditBox = true
      this.form = {
        participant_type: '',
        company_name: '',
        // company_ename: '',
        street: '',
        city: '',
        country: '',
        homepage: '',
        address_email: '',
        address_fax: '',
        user: [{
          participant_type: '',
          form: '',
          firstname: '',
          lastname: '',
          email: '',
          position: '',
          phone: '',
          other_name: ''
        }]
      }
      addressGetDesignInfo(this.$route.query.userId || this.user.id).then(res => {
        console.log(res)
        // this.form.city = res.address.city
        // this.form.company_ename = res.address.company_ename
        // this.form.company_name = res.address.company_name
        // this.form.country = res.address.country
        // this.form.homepage = res.address.homepage
        // this.form.street = res.address.street
      })
    },
    editAddress(index) {
      console.log('index', index)
      this.choose(index)
      this.showEditBox = true
      const form = this.list[this.editIndex]
      console.log('form', form)
      this.form.user = form.contact
      this.form.company_name = form.company_name
      // this.form.company_ename = form.company_ename
      this.form.street = form.street
      this.form.city = form.city
      this.form.country = form.country
      this.form.province = form.province
      this.form.region = form.region
      this.form.homepage = form.homepage
      this.form.address_email = form.email
      this.form.address_fax = form.fax
      // 如果原始数据中有participant_type，保留它
      if (form.participant_type !== undefined) {
        this.form.participant_type = form.participant_type
      }
      for (const i in this.form.user) {
        this.form.user[i].form = String(this.form.user[i].form || '')
      }
      // 国家城市中英文显示转换
      const indexCity = cityFormat['zh'].indexOf(this.form.city)
      const indexCity2 = cityFormat['en'].indexOf(this.form.city)
      const indexCountry = countryFormat['zh'].indexOf(this.form.country)
      const indexCountry2 = countryFormat['en'].indexOf(this.form.country)
      if (indexCity !== -1) this.form.city = cityFormat[this.$i18n.locale][indexCity]
      if (indexCity2 !== -1) this.form.city = cityFormat[this.$i18n.locale][indexCity2]
      if (indexCountry !== -1) this.form.country = countryFormat[this.$i18n.locale][indexCountry]
      if (indexCountry2 !== -1) this.form.country = countryFormat[this.$i18n.locale][indexCountry2]
    },
    setAddress() {
      this.isEdit = true
      let i = 0
      while (i < this.chooseIndex.length) {
        this.$emit(
          'setAddress',
          JSON.parse(JSON.stringify(this.list[this.chooseIndex[i++]]))
        )
      }
    },
    choose(index) {
      // this.chooseIndex = index
      this.editIndex = index
      this.isEdit = true
    },
    chooseBox(values, index) {
      // if (values[0] || values[0] === 0) {
      // this.chooseIndex.push(values[0])
      this.$set(this.chooseIndex, 0, values[0])
      // } else {
      //   const index = this.chooseIndex.indexOf(index)
      //   this.chooseIndex.splice(index, 1)
      // }
    },
    addUser() {
      this.form.user.push({
        participant_type: '',
        form: '',
        title: '',
        firstname: '',
        lastname: '',
        email: '',
        position: '',
        phone: '',
        other_name: ''
      })
    },
    reduceUser(index) {
      const length = this.form.user.length
      if (length > 1) this.form.user.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.address {
  width: 100%;
  margin-bottom: 90px;
}

.list {
  clear: both;
  padding-top: 24px;
  font-size: 16px;
  margin-bottom: 30px;
  /* padding-right: 80px; */
}

.item {
  background: #ffffff;
  padding: 28px 15px;
  margin-bottom: 26px;
  border: 1px solid transparent;
  position: relative;
}

.item.active {
  border: 1px solid rgba(237, 28, 36, 1);
}

.itemRadio {
  position: absolute;
  left: -50px;
  top: 55px;
}

.redStar::before {
    display: inline-block;
          margin-right: 4px;
          color: #f5222d;
          font-size: 14px;
          font-family: SimSun, sans-serif;
          line-height: 1;
          content: '*';
}

.all {
    width: 81% !important;
    height: 100% !important;
    position: fixed !important;
}

.editBox {
  position: absolute;
  top: 0;
  background: #f8f8f8;
  padding-bottom: 90px;
  overflow-y: scroll;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}
.editBox::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.subTitle {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 17px;
}

.tip {
  font-size: 14px;
  color: #999999;
  margin-top: 4px;
  line-height: 14px;
  clear: both;
  margin-bottom: 100px;
}

.user {
  padding-top: 16px;
  clear: both;
}

.user + .user {
  border-top: 1px solid #cccccc;
}

footer {
  width: 100%;
  height: 70px;
  text-align: right;
  padding: 19px 24px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
}

footer button {
  margin-left: 16px;
}
</style>
<style>
  .address .changeLine .ant-form-item-label{
    white-space: normal;
    text-align: left;
  }

  /* .address .ant-radio-inner {
    border-color: rgba(237, 28, 36, 1)
  } */
</style>
